<script lang="ts">
	import TopBanner from '$lib/banners/TopBanner.svelte'
	// import ValueBanner from '$lib/banners/ValueBanner.svelte'
	import ReviewsIo from '$lib/components/common/ReviewsIo.svelte'
	import ProductsSlider from '$lib/components/ProductsSlider.svelte'
	import ProductsRows from '$lib/components/ProductsRows.svelte'
	import ProductGallery from '$lib/components/product/ProductGallery.svelte'
	import ProductTabs from '$lib/components/product/ProductTabs.svelte'
	import BrandsBanner from '$lib/banners/BrandsBanner.svelte'
	import CompensationBanner from '$lib/flexible/blocks/CompensationBanner.svelte'
	import ProductBanner from '$lib/flexible/blocks/ProductBanner.svelte'
	import ProductReviews from '$lib/components/product/ProductReviews.svelte'
	import ProductData from '$lib/components/product/ProductData.svelte'
	import ProductImage from '$lib/components/product/ProductImage.svelte'
	import ImageModal from '$lib/modals/ImageModal.svelte'
	import { is_set_array, is_set_object } from '$lib/js/helpers'
	import { page } from '$app/stores'
	import { storeVisitedProducts } from '$lib/js/stores'
	import { t } from 'svelte-i18n-lingui'
	import type { FullProduct, LinkedProduct, SizedImage } from '$lib/js/elasticsearch/types'
	import type { FAQEntry } from '$lib/js/strapi/types'
	import { onMount } from 'svelte'
	import { refreshRelatedProductPrices } from '$lib/js/products'
	import { getContextScope } from '$lib/js/helpers/i18n'

	const scope = getContextScope()

	export let product: FullProduct

	let related_prods: LinkedProduct[] = is_set_object($page.data.parent) ? $page.data.parent?.related_products : product.related_products
	let cross_sell_prods_promise: Promise<LinkedProduct[]>
	let upsell_prods_promise: Promise<LinkedProduct[]>

	let product_banner = $page.data.product_banner
	let faqs: FAQEntry[] | undefined = $page.data.faqs

	$: innerWidth = 0
	$: yPos = 0
	$: showReviews = false

	$: if (yPos > 1000) {
		showReviews = true
	}

	/* Media gallery */
	let showImg = false
	let imgIndex = 0

	$: uCols = is_set_object(product_banner) ? 'two-cols' : ''

	let productGallery: {
		resized_image: SizedImage
		resized_small_image: SizedImage
	}[] = []

	if (is_set_array(product.media_gallery)) {
		// Exclude videos
		productGallery = product.media_gallery.filter((entry) => !entry.vid)
	} else if (is_set_object($page.data.parent)) {
		productGallery = $page.data.parent.media_gallery.filter((entry) => !entry.vid)
	} else {
		productGallery.push(product)
	}

	// let promo_prods: BaseProduct[] = []

	// let promo: string = ''
	// let skus: Array<string> = []
	// let slider_title = ''

	// BX. Special product promo.
	// if (product?.manufacturer === 26940) {
	// 	skus = [
	// 		'B1A8AHNF85',
	// 		'B14JMEPSX3',
	// 		'B1CE339RVY',
	// 		'B1C2QYQFB9',
	// 		'B1J5B7PL3K',
	// 		'B1583FJY2X',
	// 		'B1732K4NF2',
	// 		'B1DFA4YFLK',
	// 	]
	// 	slider_title = $t`Special promo for Alessi!`
	// 	promo = 'alessi'
	// } else if (product?.manufacturer === 25972) {
	// 	skus = [
	// 		'B1FT3EQYAG',
	// 		'B1626AKN4L',
	// 		'B1BW3LRTYR',
	// 		'B154YEAACA',
	// 		'B16ERW5JAP',
	// 		'B1KBZDAEZL',
	// 		'B1AET5ELL9',
	// 		'B16F94LCH4',
	// 	]
	// 	slider_title = $t`Special promo for Fissler!`
	// 	promo = 'fissler'
	// }

	// Reload prices of related products
	let isUpdated = false

	onMount(async () => {
		// let options = {
		// 	start: 1,
		// 	size: 8,
		// 	sort: {},
		// 	min_price: 0,
		// 	max_price: 200000,
		// 	search_text: product.name,
		// 	cat_id: undefined,
		// }

		// const response = await getMoreProducts(options, 'search_products')

		// BX. Special product promo.
		// if (is_set_array(skus)) {
		// 	const response_skus = await fetch(`/${scope}/endpoints/sku_products`, {
		// 		method: 'POST',
		// 		body: JSON.stringify(skus),
		// 		headers: {
		// 			'Content-Type': 'application/json',
		// 		},
		// 	})
		// 	promo_prods = await response_skus.json()
		// 	promo_prods = promo_prods.filter((el) => el !== null)
		// }

		// TODO[perf]: mutualise the calls to refreshRelatedProductPrices
		// Set related products correct prices
		if (is_set_array(related_prods)) {
			related_prods = await refreshRelatedProductPrices(related_prods, { scope: scope })
			isUpdated = true
		}

		if (is_set_array(product.cross_sell_products) || is_set_array($page.data.parent?.cross_sell_products)) {
			cross_sell_prods_promise = refreshRelatedProductPrices(is_set_object($page.data.parent) ? $page.data.parent?.cross_sell_products : product.cross_sell_products, { scope: scope })
		}

		if (is_set_array(product.upsell_products) || is_set_array($page.data.parent?.upsell_products)) {
			upsell_prods_promise = refreshRelatedProductPrices(is_set_object($page.data.parent) ? $page.data.parent?.upsell_products : product.upsell_products, { scope: scope })
		}
	})
	// window.onscroll = async function () { await updatePrices() }

	// async function updatePrices() {
	// 	cross_sell_prods = await setProductsPrices(cross_sell_prods)
	// 	upsell_prods = await setProductsPrices(upsell_prods)
	// }
</script>

<svelte:window bind:scrollY={yPos} bind:innerWidth />

<div class="product-content">
	<div class="product-content__inner">
		<TopBanner />
		<!-- <div class="special-top-banner">
			<div class="special-top-banner__overlay"></div>
			<p><span class="icon icon-van"/>{$t`En estas fechas los plazos de entrega pueden extenderse. ¡Haz tu pedido con anticipación para recibirlo a tiempo!`}</p>
		</div> -->

		<ProductImage {product} bind:imgIndex bind:showImg />
		<!-- <AgentsBanner /> -->

		{#if $page.data.mobile === true || innerWidth <= 768}
			<div class="product-content__data">
				<ProductData {product} />
			</div>
		{/if}

		{#key isUpdated}
			{#if is_set_array(related_prods) && related_prods[0]?.tax_class_id}
				<div class="related-products">
					<ProductsSlider products={related_prods} title={$t`Similar products`} type="product" />
				</div>
			{/if}
		{/key}

		<div class="product-content__banners {uCols}">
			{#if is_set_object(product_banner)}
				<div class="product-content__banners__block">
					<CompensationBanner type="product" />
				</div>
				<div class="product-content__banners__block">
					<ProductBanner banner={product_banner} />
				</div>
			{:else}
				<div class="product-content__banners__block">
					<CompensationBanner />
				</div>
			{/if}
		</div>

		<!-- BX start. Special banner. Home banner -->
		<!-- <a href="https://www.sequra.com/es/con/blaqfriday-2024" target="_blank">
			<picture class="special-banner">
				<source srcset="/images/banners/banner_sequra_desktop.jpg" media="(min-width: 1100px)" />
				<img
					src="/images/banners/banner_sequra_mobile.jpg"
					alt="Compra con sequra este black friday y tendrás un premio asegurado"
					title="Compra con sequra este black friday y tendrás un premio asegurado"
				>
			</picture>
		</a> -->
		<!-- BX end. Special banner. Home banner -->

		<!-- BX. Special product promo. -->
		<!-- {#if is_set_array(promo_prods)}
			<div class="promo-products">
				<ProductsSlider products={promo_prods} title={slider_title} type="product" {promo} />
			</div>
		{/if} -->

		<ProductTabs {product}>
			{#if is_set_array(product.media_gallery)}
				<ProductGallery gallery={product.media_gallery} bind:imgIndex bind:showImg />
			{/if}
		</ProductTabs>

		{#if is_set_array($page.data.reviews) && $page.data.product.rating_average >= 3}
			<ProductReviews {product} reviews={$page.data.reviews} />
		{/if}

		<!-- {#if faqs && faqs.length > 0}
			<div class="faqs">
				<FAQs {faqs} />
			</div>
		{/if} -->

		<BrandsBanner type="product" />

		{#if $storeVisitedProducts && $storeVisitedProducts.length > 1}
			<div class="u-products-slider">
				<ProductsSlider
					products={$storeVisitedProducts}
					title={$t`Recently-viewed products`}
					type="product"
				/>
			</div>
		{/if}

		{#if cross_sell_prods_promise}
			{#await cross_sell_prods_promise}
				<span></span>
			{:then cross_sell_prods}
				{#if is_set_array(cross_sell_prods)}
					<div class="u-products-slider upsell">
						{#if $page.data.mobile === false || innerWidth > 1024}
							<ProductsRows
								products={cross_sell_prods}
								title={$t`We've found some more products you may like!`}
							/>
						{:else}
							<ProductsSlider
								products={cross_sell_prods}
								title={$t`We've found some more products you may like!`}
								type="product"
							/>
						{/if}
						<a
							href="/{scope}/catalogsearch/result?q={product.name}"
							class="more-products u-btn u-btn--black">{$t`More products like this`}</a
						>
					</div>
				{/if}
			{:catch error}
				<p style="display: none">{error}</p>
			{/await}
		{/if}

		{#if upsell_prods_promise}
			{#await upsell_prods_promise}
				<span></span>
			{:then upsell_prods}
				{#if is_set_array(upsell_prods)}
					<div class="u-products-slider upsell">
						{#if $page.data.mobile === false || innerWidth > 1024}
							<ProductsRows
								products={upsell_prods}
								title={$t`Some more related products for you!`}
							/>
						{:else}
							<ProductsSlider
								products={upsell_prods}
								title={$t`Some more related products for you!`}
								type="product"
							/>
						{/if}
					</div>
				{/if}
			{:catch error}
				<p style="display: none">{error}</p>
			{/await}
		{/if}

		{#if showReviews}
			<ReviewsIo />
		{/if}

		<div class="to-top">
			{#if is_set_array(product.category)}
				<div class="breadcrumbs">
					<h2 class="head-4">{$t({message: 'You are currently here', context: 'breadcrumbs'})}</h2>

					{#each product.category.sort((a, b) => a.slug.split('/').length - b.slug.split('/').length) as option, i}
						<a style="order: {option.position}" href="/{scope}/{option.slug}">
							{#if i === 0}Bixoto{/if}
							{option.name}
							<span>></span>
						</a>
					{/each}
				</div>
			{/if}

			<button class="u-btn u-btn--black" on:click={() => document.body.scrollIntoView({ behavior: 'smooth' })}>
				{$t`Back to top`} <span class="icon icon-arr-right"></span>
			</button>
		</div>
	</div>
</div>

{#if showImg}
	<ImageModal productImages={productGallery} bind:showImg bind:imgIndex />
{/if}

<style lang="scss">
  // BX start. Special banner. Home banner
  // .special-top-banner {
  //   position: relative;
  //   padding: 10px 12px;
  //   margin: -20px -20px 20px;
  //   background: var(--color-grey);

  //   @media (min-width: 480px) {
  //     padding: 10px 15px;
  //   }

  //   @media (min-width: 769px) {
  //     margin-left: -35px;
  //     margin-right: -35px;
  //     padding: 10px 15px 10px 0;
  //   }

  //   @media (min-width: 769px) {
  //     margin-left: 0;
  //     margin-right: -50px;
  //   }

  //   &__overlay {
  //     position: absolute;
  //     top: 0;
  //     bottom: 0;
  //     right: 0;
  //     background: var(--color-grey);
  //     z-index: -1;

  //     @media (min-width: 769px) {
  //       left: calc((100% - 100vw) / 2);
  //     }
  //   }

  //   p {
  //     @media (max-width: 480px) {
  //       font-size: 12px;
  //     }
  //   }

  //   span {
  //     margin-right: 5px;
  //   }
  // }

  // BX end. Special banner. Home banner

  // BX start. Special banner. Home banner
  // .special-banner {
  // 	width: 100%;
  // 	display: flex;
  // 	margin-bottom: 30px;
  // 	margin-top: 20px;

  // 	@media (max-width: 768px) {
  // 		width: calc(100%);
  // 		margin-top: 10px;
  // 	}

  // 	img {
  // 		width: 100%;
  // 	}
  // }
  // BX end. Special banner. Home banner

  // .promo-products {
  // 	margin: 60px 0 40px;
  // }
  .u-products-slider {
    margin: 60px 0;

    @media (min-width: 769px) {
      margin: 80px 0;
    }
  }

  .to-top {
    @media (min-width: 1024px) {
      display: flex;
      gap: 40px;
      justify-content: space-between;
      align-items: flex-end;
    }

    button {
      min-width: 200px;
      margin: 30px 0 0;
      padding: 8px 25px;

      @media (max-width: 768px) {
        padding: 10px 25px;
        width: 100%;
      }

      span {
        display: inline-block;
        transform: rotate(-90deg);
        font-size: 8px;
      }
    }
  }

  .related-products {
    padding-top: 20px;
    padding-bottom: 50px;
  }

  .breadcrumbs {
    @media (max-width: 768px) {
      margin-top: 20px;
      padding: 20px 0 22px;
      border-top: 1px solid var(--grey);
      border-bottom: 1px solid var(--grey);
    }

    a {
      color: black;

      &:hover {
        color: var(--main);
      }

      &:last-child {
        span {
          display: none;
        }
      }

      span {
        margin: 0 10px;
      }
    }
  }

  .product-content {
    &__inner {
      padding: 0 20px;

      @media (min-width: 769px) {
        padding: 0 35px;
      }

      @media (min-width: 769px) {
        padding: 0 50px;
      }

      .faqs {
        margin: 50px 0 20px;
      }
    }

    &__data {
      @media (min-width: 769px) {
        display: none;
      }
    }

    &__banners {
      @media (min-width: 769px) {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        grid-gap: 15px;
      }

      &.two-cols {
        @media (min-width: 769px) {
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 5px;
        }

        @media (max-width: 768px) {
          margin-left: -20px;
          margin-right: -20px;
        }
      }

      &.three-cols {
        @media (min-width: 769px) {
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 10px;
        }
      }

      &__block {
        height: 100%;
        overflow: hidden;
        // border-radius: 5px;
        transition: all linear 0.125s;

        @media (max-width: 1024px) {
          margin-bottom: 8px;
        }

        // @media (min-width: 769px) {
        //   &:hover {
        //     transform: translateY(-5px);
        //   }
        // }
      }
    }
  }

  .more-products {
    margin: 10px auto 0;

    @media (min-width: 769px) {
      margin: 30px auto 0;
    }
  }

  .upsell {
    text-align: center;
  }
</style>
